import type { Maybe } from '@/helpers/types';

import { findSubscriptionBy } from '@/helpers/pro-web-helper';
import { getOrCreateSubscriber } from '@/libraries/revenueCat';

export async function updatePremiumStatus(jwId: Maybe<string>) {
	let newPremiumStatus = false;

	const purchaserInfo = await getOrCreateSubscriber(jwId);

	if (purchaserInfo) {
		const expireDate = purchaserInfo.subscriber?.entitlements['Pro']?.expires_date;

		if (expireDate) {
			newPremiumStatus = new Date(expireDate).getTime() > Date.now();
		} else {
			const product_identifier = purchaserInfo.subscriber?.entitlements['Pro']?.product_identifier;
			newPremiumStatus = findSubscriptionBy('id', product_identifier)?.timeframe === 'one time';
		}
	}

	const subscriptionId = newPremiumStatus
		? purchaserInfo?.subscriber?.entitlements['Pro']?.product_identifier ?? null
		: null;

	return { newPremiumStatus, subscriptionId, purchaserInfo };
}
